<template>
    <div>
        <div class="app-page-title">
            <div class="page-title-wrapper">
                <div class="page-title-heading">
                    <div class="page-title-icon">
                        <i :class="icon"/>
                    </div>
                    <div>
                        {{heading}}
                        <div
                                class="page-title-subheading">
                            {{subheading}}
                        </div>
                    </div>
                </div>
                <div class="page-title-actions">
                    <router-link :to="{name: 'client-add'}"
                                 class="btn-shadow d-inline-flex align-items-center btn btn-success">
                        <font-awesome-icon class="mr-2" icon="plus"/>
                        Ajouter
                    </router-link>
                </div>
            </div>
        </div>

        <b-card title="Basic" class="main-card mb-4">
            <b-row>
                <b-col md="6" class="my-1">
                    <b-form-group horizontal label="Filter" class="mb-0">
                        <b-input-group>
                            <b-form-input v-model="filter" placeholder="Type to Search"/>
                            <b-input-group-append>
                                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="6" class="my-1">
                    <b-form-group horizontal label="Sort" class="mb-0">
                        <b-input-group>
                            <b-form-select v-model="sortBy" :options="sortOptions">
                                <option slot="first" :value="null">-- none --</option>
                            </b-form-select>
                            <b-form-select :disabled="!sortBy" v-model="sortDesc" slot="append">
                                <option :value="false">Asc</option>
                                <option :value="true">Desc</option>
                            </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="6" class="my-1">
                    <b-form-group horizontal label="Sort direction" class="mb-0">
                        <b-input-group>
                            <b-form-select v-model="sortDirection">
                                <option value="asc">Asc</option>
                                <option value="desc">Desc</option>
                                <option value="last">Last</option>
                            </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="6" class="my-1">
                    <b-form-group horizontal label="Per page" class="mb-0">
                        <b-form-select :options="pageOptions" v-model="perPage"/>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Main table element -->
            <b-table show-empty
                     stacked="md"
                     :items="clients"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection"
                     @filtered="onFiltered"
            >
                <template v-slot:cell(sampleDate)="row">{{row.item.sampleDate | date}}</template>
                <template v-slot:cell(name)="row">
                    <router-link :to="{name: 'client',params: {id: row.item.id}}">
                        {{row.item.first_name}} {{row.item.last_name}}
                    </router-link>
                </template>
                <template v-slot:cell(birthday)="row">{{row.item.birthday | date}}</template>
                <template v-slot:cell(blood)="row">{{row.item.type}} {{row.item.r}}</template>
                <template v-slot:cell(actions)="row">
                    <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                    <b-button size="sm" @click.stop="row.toggleDetails">
                        {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                    </b-button>
                </template>
                <template v-slot:cell(actions)="row">
                    <div class="btn-group">
                        <router-link class="btn btn-primary" :to="{name: 'client',params: {id: row.item.id}}">
                            <font-awesome-icon class="mr-2" icon="search"/>
                        </router-link>
                        <button class="btn btn-primary" @click="generatePDF(row.item,true)">
                            <font-awesome-icon class="mr-2" icon="print"/>
                        </button>
                        <router-link :to="{name: 'client-edit', params: {id: row.item.id}}"
                                     class="btn btn-primary">
                            <font-awesome-icon class="mr-2" icon="edit"/>
                        </router-link>
                    </div>
                </template>
            </b-table>

            <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"/>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>

import moment from 'moment'
import PDF from '@/mixins/PDF'

export default {
  name: 'Clients',
  mixins: [PDF],
  data: () => ({
    heading: 'Tout les Clients',
    subheading: 'les information de tt les cilents',
    icon: 'pe-7s-users icon-gradient bg-mixed-hopes',

    fields: [
      { key: 'sampleDate', label: 'Date de prélèvement', sortable: true },
      { key: 'name', label: 'Client', sortable: true },
      { key: 'birthday', label: 'date de naissance', sortable: true },
      { key: 'blood', label: 'Group' },
      { key: 'actions', label: 'Actions' }
    ],
    clients: [],
    currentPage: 1,
    perPage: 5,
    pageOptions: [5, 10, 15],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    filter: null,
    modalInfo: {
      title: '',
      content: ''
    }
  }),
  filters: {
    date (d) {
      return moment(new Date(d)).locale('fr').format('DD/MM/YYYY')
    }
  },
  computed: {
    totalRows () {
      return this.clients.length
    },
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return {
            text: f.label,
            value: f.key
          }
        })
    }
  },
  methods: {
    info (item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal () {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  mounted () {
    this.clients = Object.values(this.$store.getters.clients)
  }
}
</script>
